import { Allan, Barlow_Condensed, Bebas_Neue, Caesar_Dressing, Caveat, Cinzel, Comfortaa, Cormorant_Garamond, Courgette, Dancing_Script, Edu_NSW_ACT_Foundation, Englebert, Grenze_Gotisch, Hind_Madurai, Inter, Josefin_Sans, Kaushan_Script, Lora, Love_Ya_Like_A_Sister, Marcellus, Oregano, Philosopher, Playfair_Display, Poiret_One, PT_Serif, Ranga, Roboto, Satisfy, Snippet, Stick_No_Bills, Sunshiney, Teko, Truculenta, Volkhov } from 'next/font/google'
import { retiredMenuFontIds, safeMenuFontIds, isSafeMenuFont } from './menuFonts'
import type { MenuFontId } from './menuFonts'

export const barlowCondensed = Barlow_Condensed({ subsets: ['latin'], weight: ['400', '600'], display: 'swap' })
export const teko = Teko({ subsets: ['latin'], weight: '400', display: 'swap' })
export const comfortaa = Comfortaa({ subsets: ['latin'], weight: ['400', '600'], display: 'swap' })
export const inter = Inter({ subsets: ['latin'], weight: ['400', '800'], display: 'swap' })
export const roboto = Roboto({ subsets: ['latin'], weight: ['400', '700'], display: 'swap' })

// Para personalización
export const truculenta = Truculenta({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const loveYa = Love_Ya_Like_A_Sister({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const hindMadurai = Hind_Madurai({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const grenze = Grenze_Gotisch({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const edu = Edu_NSW_ACT_Foundation({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const caesarDressing = Caesar_Dressing({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const dancingScript = Dancing_Script({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const stickNoBills = Stick_No_Bills({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const allan = Allan({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const oregano = Oregano({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const sunshiney = Sunshiney({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const snippet = Snippet({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const ranga = Ranga({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const englebert = Englebert({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const playfairDisplay = Playfair_Display({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const lora = Lora({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const cinzel = Cinzel({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const caveat = Caveat({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const courgette = Courgette({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const cormorantGaramond = Cormorant_Garamond({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const marcellus = Marcellus({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const ptSerif = PT_Serif({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const poiretOne = Poiret_One({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const bebasNeue = Bebas_Neue({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const kaushanScript = Kaushan_Script({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const satisfy = Satisfy({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const philosopher = Philosopher({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const josefinSans = Josefin_Sans({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })
export const volkhov = Volkhov({ subsets: ['latin'], weight: '400', display: 'swap', preload: false })

export type FontId = MenuFontId

// Tipado Record<FontId, ...> obliga a que cada fuente de MENU_FONT_DEFS tenga
// su objeto next/font aquí (y que no sobre ninguna). Las fuentes retiradas se
// mantienen para que los bares que ya las usan sigan funcionando.
export const menuFonts: Record<FontId, typeof barlowCondensed> = {
  barlowCondensed,
  truculenta,
  loveYa,
  hindMadurai,
  grenze,
  edu,
  caesarDressing,
  dancingScript,
  stickNoBills,
  allan,
  oregano,
  sunshiney,
  snippet,
  ranga,
  englebert,
  playfairDisplay,
  lora,
  cinzel,
  caveat,
  courgette,
  cormorantGaramond,
  marcellus,
  ptSerif,
  poiretOne,
  bebasNeue,
  kaushanScript,
  satisfy,
  philosopher,
  josefinSans,
  volkhov
}

export { retiredMenuFontIds, safeMenuFontIds, isSafeMenuFont }
